import { Injectable } from "@angular/core";
import { AppConfiguration, GenesysConfiguration, ProtectedResource, WorkerConfig } from "./app.config";
import { Configuration } from "@azure/msal-browser";
import { AuthConfig } from "angular-oauth2-oidc";

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: AppConfiguration | undefined;

  async loadConfigToService(): Promise<any> {
    if (!this.appConfig) {
      let currentDate = new Date();
      return fetch(`/assets/app.config.json?q=` + currentDate.toISOString())
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load configuration');
        }
        return response.json();
      })
      .then((config) => {
        this.appConfig = config;
      });
    } else {
      return Promise.resolve(this.appConfig);
    }
  }

  get config(): AppConfiguration | undefined {
    return this.appConfig;
  }

  get msalConfig(): Configuration | undefined {
    return this.appConfig?.msal;
  }
  
  get workerConfig(): WorkerConfig | undefined {
    return this.appConfig?.workerConfig;
  }


  get protectedResources(): ProtectedResource | undefined {
    return this.appConfig?.protectedResources;
  }

  get genesysConfiguration(): GenesysConfiguration | undefined {
    return this.appConfig?.genesys;
  }
  get genesysAuthConfig() : AuthConfig {
    return {
      loginUrl: `https://login.${this.genesysConfiguration?.environment}/oauth/authorize`,
      issuer: `https://${this.genesysConfiguration?.environment}`,
      redirectUri: `${this.genesysConfiguration?.redirectUri}`,
      clientId: this.genesysConfiguration?.clientId,
      responseType: 'token',
      preserveRequestedRoute: true,
      oidc: false,
      scope: '',
      showDebugInformation: true,
      clearHashAfterLogin: false,
      requestAccessToken: true,
      nonceStateSeparator: '#',
      silentRefreshShowIFrame: false,
      silentRefreshRedirectUri: `${this.genesysConfiguration?.refreshUri}`
    }
  }
}
